import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import {
  OUTBOUND_QTY_STAT_LABEL_CLASS,
  OUTBOUND_QTY_STAT_VALUE_COUNT_MIN_WIDTH_CLASS,
  OUTBOUND_QTY_STAT_VALUE_QTY_MIN_WIDTH_CLASS,
  outboundQtyStatValueClassName,
} from '#/modules/momMgmt/workOrder/outbound/helper/outboundQtyStatClasses';

function OutboundQtyStat({
  label,
  value,
  valueClassName,
  valueWidth = 'qty',
  suffix = null,
  className,
  inline = false,
}) {
  const Tag = inline ? 'span' : 'p';

  return (
    <Tag
      className={cn(
        'inline-flex items-baseline space-x-1',
        inline && 'whitespace-nowrap',
        className,
      )}
    >
      <span className={OUTBOUND_QTY_STAT_LABEL_CLASS}>{label}</span>
      <span
        className={cn(
          outboundQtyStatValueClassName(valueClassName),
          valueWidth === 'count'
            ? OUTBOUND_QTY_STAT_VALUE_COUNT_MIN_WIDTH_CLASS
            : OUTBOUND_QTY_STAT_VALUE_QTY_MIN_WIDTH_CLASS,
        )}
      >
        {value}
      </span>
      {suffix ? (
        <span className={OUTBOUND_QTY_STAT_LABEL_CLASS}>{suffix}</span>
      ) : null}
    </Tag>
  );
}

OutboundQtyStat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueClassName: PropTypes.string,
  valueWidth: PropTypes.oneOf(['qty', 'count']),
  suffix: PropTypes.string,
  className: PropTypes.string,
  inline: PropTypes.bool,
};

export default OutboundQtyStat;
